import React from 'react';
import { isDefaultLang } from '@shapeable/utils';
import { LinkComponent, useActiveLang, useLinkPathTransformer,  } from '@shapeable/ui';
import { Link } from 'gatsby';
import { trimEnd, trimStart, isString } from 'lodash';
/**
 * Simple normalizing component to convert Gatsby's "to" prop to a more typical "href" prop used in both a native Anchor, and next/link
 * Also checks if the link is truly internal, and serves up a normal link otherwise. 
 */

export const GatsbyHrefLink: LinkComponent = ({ href, activeClassName, stripPagesSlug = true, partiallyActive, patchLang = true, children, ...rest }) => {
  const isExternal = !!(href && href.match && (href.match(/data:/i) || href.match(/mailto:/i) || href.match(/http(s?)/)));
  const isDownload = href && href.match && href.match(/\.pdf$/);

  const transform = useLinkPathTransformer();
  
  let linkHref = href;

  const activeLang = useActiveLang();

  if (!isExternal && !isDownload && isString(linkHref)) {
  
    // look for lang
    if (patchLang && !isDefaultLang(activeLang)) {
      linkHref = `${trimEnd(activeLang.path, '/')}/${trimStart(href, '/')}`;
    }

    if (stripPagesSlug && isString(linkHref)) {
      linkHref = linkHref.replace(/^\/pages\//, '/');
    }

    if (isString(linkHref)) {
      linkHref = transform(linkHref);
    }
    
    if (rest.target !== '_blank') {
      return <Link to={linkHref} activeClassName={activeClassName} partiallyActive={partiallyActive} {...rest}>{children}</Link>;
    }
  }
  
  const { target = "_blank", ...linkProps } = rest;
  return <a href={linkHref} {...linkProps} target={target}>{children}</a>;
}